import { LoaderIcon } from '@src/assets/icons';

import styles from './OSpinner.module.scss';

const OSpinner = () => {
  return (
    <div className={styles.loaderWrapper}>
      <LoaderIcon width={29} height={29} />
    </div>
  );
};

export default OSpinner;
